export default __webpack_public_path__ + "847b570bd34831aef625c38ce6066109.svg";